import { ChartsYReferenceLineProps } from "@mui/x-charts-premium";

export const DEFAULT_Y_MERGE_THRESHOLD = 5;

export function mergeYReferenceLines(
  referenceLines: Array<ChartsYReferenceLineProps<number>>,
  labelsToAppend: string[],
  unit: string,
  mergeThreshold: number = DEFAULT_Y_MERGE_THRESHOLD
): Array<ChartsYReferenceLineProps<number>> {
  if (!referenceLines || referenceLines.length === 0) {
    return [];
  }

  const isAboutEqual = (a: number, b: number) =>
    Math.abs(a - b) <= mergeThreshold;

  const consolidated: Array<ChartsYReferenceLineProps<number>> = [];

  referenceLines.forEach((it, index) => {
    if (index === 0) {
      // start a new run
      consolidated.push({ ...it });
    } else {
      // Compare against the current run's y (running max), not only the immediate previous item.
      const last = consolidated[consolidated.length - 1];
      if (!isAboutEqual(it.y, last.y)) {
        // close previous run with its current max y
        consolidated[consolidated.length - 1] = {
          ...last,
          label: `${last.label}): ${last.y} ${unit}`,
        };
        // start a new run
        consolidated.push({ ...it });
      } else {
        // extend current run and bump y to the max within the run
        const appendLabel = labelsToAppend[index];
        const newY = Math.max(last.y, it.y);
        consolidated[consolidated.length - 1] = {
          ...last,
          y: newY,
          label: `${last.label}, ${appendLabel}`,
        };
      }
    }
  });

  // finalize the last run with its max y
  const last = consolidated[consolidated.length - 1];
  consolidated[consolidated.length - 1] = {
    ...last,
    label: `${last.label}): ${last.y} ${unit}`,
  };

  return consolidated;
}
